<template>
  <div class="py-2.5 px-5" id="mvc">
    <div class="flex w-full flex-col sm:flex-row gap-2" style="height: calc(100vh - 112px);" >
      <div class="sm:flex flex-col h-[calc(100vh - 200px)] sm:w-1/2 justify-between sm:order-first order-last">
        <div class="pane-title blue-light font-bold uppercase mb-2 sm:flex justify-between">
          <div>
            <i class="bi bly-output"></i> Sources <span class="loading" style="display: none;"></span>
          </div>
          <div class="title-actions max-h-72 flex items-center">
            <el-select
              size="small"
              class="bg-black"
              placeholder="Select group"
              clearable
              @change="sourceGroupChanged"
              v-model="selectedSourceGroup" value-key="id">
              <el-option
                v-for="group in sourceGroups"
                :key="group.id"
                :label="group.name"
                :value="group">
              </el-option>
            </el-select>
            <el-divider direction="vertical" v-if="!isMobileOnly"></el-divider>
            <div class="search" v-if="!isMobileOnly">
              <el-input
                placeholder="Search sources..."
                size="small"
                clearable
                @change="searchSourceChanged"
                v-model="searchSource">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
          </div>
        </div>
        <div v-bar style="height: calc(100vh - 200px);">
          <div>
            <div class="flex flex-wrap gap-2 h-[calc(100vh - 200px)] p-2" >
              <div
                v-for="source in sortedSources" :key="source.id"
                @click="sendRouteCommand(source, dest)"
                :class="{ 'bg-yellow-500': sourceDestinations[source.id].indexOf(dest.id) !== -1, 'loading-item': showTakeId === source.id}"
                class="group bg-gray-700 w-24 h-16 text-white flex items-center rounded-xs
              justify-center flex-col text-xs p-2 text-center break-all max-h-[calc(100vh - 200px)] hover:ring-2 hover:ring-yellow-500 cursor-pointer relative">{{source.name}}
              <div class="absolute top-1 left-1 right-1 bottom-1 items-center justify-center bg-yellow-500 hidden">ROUTE</div></div>
            </div>
          </div>
        </div>
        <div class="mt-4 flex flex-wrap gap-2 p-2">
          <div v-for="channel in availableAudioChannels" :key="channel" class="w-24 h-14 text-white flex items-center
           justify-center flex-col hover:ring-2 hover:ring-yellow-500 cursor-pointer"
            @click="audioChange(activeMV, channel)"
            :class="{'bg-yellow-500': activeMV.activeAudioChannel === channel, 'bg-gray-700': activeMV.activeAudioChannel !== channel }">
            <div class="opacity-60 text-xs">Audio</div>
            <div class="font-">{{channel}}</div>
          </div>
        </div>
      </div>
      <div class="sm:w-1/2 flex items-start justify-center sm:order-last -order-1">
          <div id="player" class="w-full"></div>
          <!-- <pre>
            {{activeMV}}
          </pre> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      sldpPlayer: null,
      showTakeId: null,
      selectedSourceGroup: null,
      searchSource: '',
      channels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      checkInterval: null,
      dest: {
          "id": "destination-ksd-IMG/MV-MV_Preview_01",
          "name": "MV_Preview_01",
          "description": "MV_Preview_01",
          "originRouterGroup": "Sites/IMG/MV",
          "originRouterDestinationId": "MV_Preview_01",
          "originRouterId": "ksd",
          "claimsCanAccess": [
            "usr.ma.ma"
          ],
          "claimsCanEdit": [
            "usr.ma.ma"
          ],
          "version": 13,
        },
    };
  },
  computed: {
    ...mapState({
      // loading: state => state.permissions.loading,
      clients: (state) => state.permissions.clients,
      claims: (state) => state.permissions.claims,
      client: (state) => state.userAccount.client,
      account: (state) => state.userAccount.account,
      inputs: (state) => state.permissions.inputs,
      outputs: (state) => state.permissions.outputs,
      routerDestinations: (state) => state.permissions.routerDestinations,
      routerSources: (state) => state.permissions.routerSources,
      routerGroups: (state) => state.router.routerGroups,
      configuration: (state) => state.multiviewCinegy.configuration,
    }),
    activeMV() {
      if (!this.configuration) return {
        audioChannels: 0,
        activeAudioChannel: 0,
      };
      return this.configuration
        .find((item) => item.id === '6181M');
    },
    userId() {
      return this.userSession.idToken.payload.sub;
    },

    availableAudioChannels() {
      return this.channels.filter((item, index) => index < this.activeMV.audioChannels);
    },

    accountId() {
      return this.account.code;
    },

    clientId() {
      return this.client.code;
    },

    claimsCanEdit() {
      return [
        `ro.${this.accountId}.${this.clientId}`,
      ];
    },

    sourceDestinations() {
      const sources = {};
      this.sortedSources
        .forEach((item) => {
          sources[item.id] = [];
          item.routedDestinations.items.forEach((dest) => sources[item.id].push(dest.id));
        });
      return sources;
    },

    claimsCanAccess() {
      return [
        `rv.${this.accountId}.${this.clientId}`,
        `ro.${this.accountId}.${this.clientId}`,
      ];
    },
    //
    // output profile edit - outputs access test
    sortedDest() {
      return this.routerDestinations
        .slice(0)
        .sort((a, b) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        });
    },
    sourceGroups() {
      if (!this.routerGroups) return [];
      return this.routerGroups.items.filter((item) => item.sources.items.length > 0)
        .sort((a, b) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        });
    },
    sortedSources() {
      if (!this.routerSources) return [];
      const filterBySearchString = this.searchSource.length > 2;
      if (filterBySearchString) {
        const seachString = this.searchSource.toLowerCase();
        return this.routerSources
          .filter((item) => item.name.toLowerCase().indexOf(seachString) !== -1)
          .sort((a, b) => {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
          });
      }
      if (this.selectedSourceGroup) {
        return this.routerSources
          .filter((item) => {
            const groupIds = item.routerGroups.items.map((group) => group.routerGroup.id);
            return groupIds.indexOf(this.selectedSourceGroup.id) !== -1;
          })
          .sort((a, b) => {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
          });
      }
      return this.routerSources
        .slice(0)
        .sort((a, b) => {
          if (a.name < b.name) { return -1; }
          if (a.name > b.name) { return 1; }
          return 0;
        });
    },
  },
  beforeDestroy() {
    this.checkInterval 
    clearInterval(this.checkInterval, this.fetchConfiguration);
  },
  mounted() {
    this.selectedSourceGroup = {"id":"ksd-Sites/IMG-sto","name":"Sites/IMG","claimsCanAccess":["usr.ma.ma"],"claimsCanEdit":["usr.ma.ma"],"version":7,"lastUpdatedBy":{"id":"system","name":"System","email":"system@mediaatmos.com"},"router":{"id":"sto","name":"STO01","description":"Stockholm IP router","claimsCanAccess":["usr.ma"],"claimsCanEdit":["usr.ma"],"version":1},"sources":{"items":[{"id":"1c9c34b9-0d08-40ba-bc89-7d9484346992","routerSource":{"id":"source-ksd-IMG-IMG 115","name":"IMG 115"}},{"id":"74bfdbd0-a2c6-421d-a877-909deafc4590","routerSource":{"id":"source-ksd-IMG-IMG 313","name":"IMG 313"}},{"id":"dd1ff557-6230-4356-a8a3-8cac16774a7b","routerSource":{"id":"source-ksd-IMG-IMG 101","name":"IMG 101"}},{"id":"d49e81c3-bd9d-4b4e-9db5-46d26c49cb5a","routerSource":{"id":"source-ksd-IMG-IMG 323","name":"IMG 323"}},{"id":"620b7b8f-f1ad-4117-be8d-72d0c6ad5d57","routerSource":{"id":"source-ksd-IMG-IMG 305","name":"IMG 305"}},{"id":"6d3ccf1e-89eb-466b-824a-d35174a29a1f","routerSource":{"id":"source-ksd-IMG-IMG 103","name":"IMG 103"}},{"id":"de06bd50-3d7b-4491-ad98-fa3f8e196924","routerSource":{"id":"source-ksd-IMG-IMG 203","name":"IMG 203"}},{"id":"d0c7dfca-5d93-46c0-9395-b0c2d322ac31","routerSource":{"id":"source-ksd-IMG-IMG 309","name":"IMG 309"}},{"id":"28187acb-a379-4f7f-9d40-9ac6f0e9916c","routerSource":{"id":"source-ksd-IMG-IMG 317","name":"IMG 317"}},{"id":"629c60ba-5109-470a-b4b4-933d84ea6594","routerSource":{"id":"source-ksd-IMG-IMG 319","name":"IMG 319"}},{"id":"86157e6e-9785-4d54-885c-67f764093c1f","routerSource":{"id":"source-ksd-IMG-IMG 205","name":"IMG 205"}},{"id":"8ead1d40-cec0-4609-b538-52dd35562c45","routerSource":{"id":"source-ksd-IMG-IMG 113","name":"IMG 113"}},{"id":"705036a2-4fbb-4f26-87b6-e2238391f83c","routerSource":{"id":"source-ksd-IMG-IMG 125","name":"IMG 125"}},{"id":"970e7121-ffa0-484b-ad78-3a3428dc4fdf","routerSource":{"id":"source-ksd-IMG-IMG 207","name":"IMG 207"}},{"id":"f689462d-b753-4206-9459-d65c78df4b8b","routerSource":{"id":"source-ksd-IMG-IMG 201","name":"IMG 201"}},{"id":"cb2e7208-b887-4868-aaea-9c24c87bb59b","routerSource":{"id":"source-ksd-IMG-STO 02","name":"STO 02"}},{"id":"9887fe3c-0c40-4147-ad79-f74f8fa7a2c5","routerSource":{"id":"source-ksd-IMG-IMG 303","name":"IMG 303"}},{"id":"34976aa6-eac7-4ef8-8ddf-b2f0a7e8a638","routerSource":{"id":"source-ksd-IMG-IMG 321","name":"IMG 321"}},{"id":"f69a7bd9-4a2c-4d27-9456-4250cf9aba95","routerSource":{"id":"source-ksd-IMG-IMG 127","name":"IMG 127"}},{"id":"7a211cf4-8e60-4d69-85f1-f71f67bcd0e8","routerSource":{"id":"source-ksd-IMG-IMG 117","name":"IMG 117"}},{"id":"5c47897c-bf0e-4876-ba11-b6b8c5956c47","routerSource":{"id":"source-ksd-IMG-IMG 223","name":"IMG 223"}},{"id":"553f22c4-a05e-4467-a87c-99bd902262f6","routerSource":{"id":"source-ksd-IMG-IMG 315","name":"IMG 315"}},{"id":"d9676eef-cf3b-42ff-be87-fe6c109b686f","routerSource":{"id":"source-ksd-IMG-IMG 213","name":"IMG 213"}},{"id":"380476ad-274e-4b49-940e-44c61c8b01d6","routerSource":{"id":"source-ksd-IMG-IMG 219","name":"IMG 219"}},{"id":"60417690-019a-456a-89d5-d378ae07d891","routerSource":{"id":"source-ksd-IMG-IMG 215","name":"IMG 215"}},{"id":"4b0316b0-1327-440f-b647-9adeba5979ed","routerSource":{"id":"source-ksd-IMG-IMG 119","name":"IMG 119"}},{"id":"25df5dbe-537f-44bf-96e2-cfc88961da61","routerSource":{"id":"source-ksd-IMG-IMG 111","name":"IMG 111"}},{"id":"64034a98-4bee-43fa-8988-67b114940848","routerSource":{"id":"source-ksd-IMG-IMG 211","name":"IMG 211"}},{"id":"90440588-8b33-4374-9e09-cdd618594fb2","routerSource":{"id":"source-ksd-IMG-IMG 121","name":"IMG 121"}},{"id":"4f41eda0-1a8f-4afe-be8a-4e65e00aeba7","routerSource":{"id":"source-ksd-IMG-IMG 405","name":"IMG 405"}},{"id":"8bbd5ccb-d5d6-41ec-b65d-c34e81bc7e69","routerSource":{"id":"source-ksd-IMG-IMG 217","name":"IMG 217"}},{"id":"d59f28ae-0087-45e1-8a50-a7b1510eef39","routerSource":{"id":"source-ksd-IMG-IMG 307","name":"IMG 307"}},{"id":"3282f4e8-627c-4087-8a83-39e3d55fb03f","routerSource":{"id":"source-ksd-IMG-IMG 209","name":"IMG 209"}},{"id":"813879b4-a478-43d3-bf23-09cc1247f9a9","routerSource":{"id":"source-ksd-IMG-IMG 105","name":"IMG 105"}},{"id":"43ae23dd-ac99-4983-b6f4-af5ca5af29e5","routerSource":{"id":"source-ksd-IMG-IMG 301","name":"IMG 301"}},{"id":"68ab2b61-0f2a-4b8d-b985-6f2b864ac005","routerSource":{"id":"source-ksd-IMG-IMG 403","name":"IMG 403"}},{"id":"4e033569-01de-49ca-bd7e-2e15a837f73f","routerSource":{"id":"source-ksd-IMG-IMG 221","name":"IMG 221"}},{"id":"ba8ad961-f823-4577-95a4-9e71d574f037","routerSource":{"id":"source-ksd-IMG-Matchroom_enc02","name":"Matchroom_enc02"}},{"id":"3dc95fca-fe0a-405b-9dce-80799e7f987f","routerSource":{"id":"source-ksd-IMG-IMG 109","name":"IMG 109"}},{"id":"eac7f479-fdac-44af-9ee6-9b2c1406d3e1","routerSource":{"id":"source-ksd-IMG-IMG 411","name":"IMG 411"}},{"id":"985bd629-93ea-4cff-9ab9-80d75309790b","routerSource":{"id":"source-ksd-IMG-IMG 123","name":"IMG 123"}},{"id":"56a3888d-d594-4866-a01a-32b364281ba2","routerSource":{"id":"source-ksd-IMG-STO 01","name":"STO 01"}},{"id":"e85a3fd3-5e26-49b3-a190-6884a1c0e6ce","routerSource":{"id":"source-ksd-IMG-STO 04","name":"STO 04"}},{"id":"4bbcf31e-0123-4c31-8016-488f0ada95c6","routerSource":{"id":"source-ksd-IMG-IMG 129","name":"IMG 129"}},{"id":"d2d5d179-071b-4a59-b38f-63fc778e5a92","routerSource":{"id":"source-ksd-IMG-STO 03","name":"STO 03"}},{"id":"ec0673dd-21ef-4ee6-abae-a8cc97e3bea9","routerSource":{"id":"source-ksd-IMG-IMG 407","name":"IMG 407"}},{"id":"caeeb2c3-c5af-41d8-bf00-d28b75cda5b7","routerSource":{"id":"source-ksd-IMG-IMG 409","name":"IMG 409"}},{"id":"b0f786dc-57c8-4196-9932-f1868dd6efc7","routerSource":{"id":"source-ksd-IMG-IMG 401","name":"IMG 401"}},{"id":"9ad11353-ee1f-479a-9102-4d60ae02f4eb","routerSource":{"id":"source-ksd-IMG-IMG 311","name":"IMG 311"}},{"id":"61236cc9-4c1a-4ea6-b12b-79461f1ab634","routerSource":{"id":"source-ksd-IMG-IMG 107","name":"IMG 107"}}],"nextToken":null},"destinations":{"items":[{"id":"f32ca39b-9d7c-40ed-9554-3daa86b48fcb","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_SCTE32_AWS_Line05","name":"SAMG_SCTE32_AWS_Line05"}},{"id":"17193716-3664-4a87-bd83-6fefa953ce4f","routerDestination":{"id":"destination-ksd-Sites/IMG-IMG 112","name":"IMG 112"}},{"id":"9eb3d312-80d4-4a03-a532-8d5dd27e1653","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_SCTE32_AWS_Line01","name":"SAMG_SCTE32_AWS_Line01"}},{"id":"a8b5b216-e202-4cda-8076-59ffe890f69b","routerDestination":{"id":"destination-ksd-Sites/IMG-IMG 114","name":"IMG 114"}},{"id":"87b9ef22-f5d3-4b6b-9b5e-bfecda0b2c54","routerDestination":{"id":"destination-ksd-Sites/IMG-IMG 102","name":"IMG 102"}},{"id":"7dfa8a6b-ef86-47cc-a35a-d818f62ace24","routerDestination":{"id":"destination-ksd-Sites/IMG-IMG 104","name":"IMG 104"}},{"id":"f5a20544-be0a-4000-971c-ed20b91e4d5d","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_ATP_04","name":"SAMG_ATP_04"}},{"id":"4f5e2714-0442-4d64-b92f-c4699751303b","routerDestination":{"id":"destination-ksd-Sites/IMG-Sport1","name":"Sport1"}},{"id":"a363d27a-a94e-46db-9a33-8c0ebf332924","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_ATP_06","name":"SAMG_ATP_06"}},{"id":"61332834-3ff2-40ae-b41f-6e3ded54bcfb","routerDestination":{"id":"destination-ksd-Sites/IMG-IMG 116","name":"IMG 116"}},{"id":"e5e28287-22fb-4e88-a5bf-1311e2cae896","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_ATP_02","name":"SAMG_ATP_02"}},{"id":"9cb40e7b-90b6-47e8-a208-3c9fcc489e3a","routerDestination":{"id":"destination-ksd-Sites/IMG-IMG 106","name":"IMG 106"}},{"id":"9e021ad9-eb02-4026-b790-78998420723d","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_SCTE32_AWS_Line03","name":"SAMG_SCTE32_AWS_Line03"}},{"id":"dec31613-0c79-4859-b5a7-3fba0c2b88af","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_SCTE32_AWS_Line08","name":"SAMG_SCTE32_AWS_Line08"}},{"id":"dee1cc2d-77dc-4b87-a923-a645f4dac40b","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_ATP_03","name":"SAMG_ATP_03"}},{"id":"11cc10ce-d6a0-42ac-9308-4366f407bd67","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_ATP_08","name":"SAMG_ATP_08"}},{"id":"9db1b532-6a38-44d1-85ae-0ef492996ad8","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_ATP_07","name":"SAMG_ATP_07"}},{"id":"e2d04425-fb16-4145-811e-9d8de55559ba","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_SCTE32_AWS_Line02","name":"SAMG_SCTE32_AWS_Line02"}},{"id":"7270bc95-f5dc-4da5-baaa-b805bee5a4e5","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_ATP_01","name":"SAMG_ATP_01"}},{"id":"3a6d57fe-e4df-4967-9b10-5869030d4790","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_SCTE32_AWS_Line04","name":"SAMG_SCTE32_AWS_Line04"}},{"id":"191ba35f-62a5-46fc-88dd-6587714f1e59","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_ATP_09","name":"SAMG_ATP_09"}},{"id":"0b8156a5-43ce-4eb6-8a9a-314a236b732c","routerDestination":{"id":"destination-ksd-Sites/IMG-IMG 110","name":"IMG 110"}},{"id":"62d224a2-2c24-4ec9-988b-a92f359997f3","routerDestination":{"id":"destination-ksd-Sites/IMG-IMG 108","name":"IMG 108"}},{"id":"620c6ddb-06a7-4063-843e-3438da148c32","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_ATP_05","name":"SAMG_ATP_05"}},{"id":"0711f9a3-dbbe-4d23-b9ad-8133307f6b69","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_SCTE32_AWS_Line06","name":"SAMG_SCTE32_AWS_Line06"}},{"id":"67113315-cefe-4619-a007-6de15710a456","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_Matchroom01","name":"SAMG_Matchroom01"}},{"id":"e0bc0549-d41d-4ad3-9a2e-331fb18648e7","routerDestination":{"id":"destination-ksd-Sites/IMG-SAMG_SCTE32_AWS_Line07","name":"SAMG_SCTE32_AWS_Line07"}}],"nextToken":null}};
    this.init();
    this.initPlayer();
    this.checkInterval = setInterval(this.fetchConfiguration, 5000);
  },
  methods: {
    ...mapActions({
      fetchRouterGroups: 'router/fetchRouterGroups',
      listInputs: 'permissions/listInputs',
      listOutputs: 'permissions/listOutputs',
      listMultiviewers: 'permissions/listMultiviewers',
      listClients: 'permissions/listClients',
      listClaims: 'permissions/listClaims',
      listRouters: 'permissions/listRouters',
      listRouterGroups: 'permissions/listRouterGroups',
      listRouterDestinations: 'permissions/listRouterDestinations',
      listRouterSources: 'permissions/listRouterSources',
      listOutputProfiles: 'permissions/listOutputProfiles',
      listTranscoderProfiles: 'permissions/listTranscoderProfiles',
      changeRoute: 'router/changeRoute',
      changeAudioChannel: 'multiviewCinegy/changeAudioChannel',
      fetchConfiguration: 'multiviewCinegy/fetchConfiguration',
    }),
    async init() {
      this.loading = true;
      this.selectedSourceGroup = JSON.parse(localStorage.getItem('mvc_selectedSourceGroup')) || null;
      this.searchSource = localStorage.getItem('mvc_searchSource') || '';

      await this.listRouterSources();
      await this.listRouterGroups();
      await this.fetchRouterGroups();
      await this.fetchConfiguration();
      this.loading = false;
    },
    initPlayer(){
      this.sldpPlayer = SLDP.init({
        container:           'player',
        stream_url:          'wss://ll-img.streams.elas.tech:8081/IMG03/MV_Preview_01',
        adaptive_bitrate: {
          initial_rendition: '240p'
        },
        buffering:           500,
        height: 'parent',
        width: 'parent',
        autoplay: true,
      });
    },

    removePlayer(){
      this.sldpPlayer.destroy(function () {
        console.log('SLDP Player is destroyed.');
      });
    },

    async sendRouteCommand(source, dest) {
      console.log('route');
      this.showTakeId = source.id;
      const command = {
        clientId: this.clientId,
        accountId: this.accountId,
        sourceId: source.id,
        destinationIds: [dest.id],
        // eventId: ID
        claimsCanAccess: this.claimsCanAccess,
        claimsCanEdit: this.claimsCanEdit,
      };
      await this.changeRoute(command);
      await this.listRouterSources();
      this.loading = true;
      this.showTakeId = null;
    },
    searchSourceChanged() {
      localStorage.setItem('mvc_searchSource', this.searchSource);
    },
    sourceGroupChanged() {
      localStorage.setItem('mvc_selectedSourceGroup', JSON.stringify(this.selectedSourceGroup));
    },
    async audioChange(multi, channel) {
      await this.changeAudioChannel({ multiviewerId: multi.id, player: multi.activePlayer, newAudioChannel: channel });
      setTimeout(async () => {
        await this.fetchConfiguration();
      }, 2000);
    },
  },
}
</script>

<style>
.group:hover .absolute {
  display: flex !important;
}
#mvc .pane-title .title-actions input {
    background: transparent;
    border-color: transparent;
    color: #CDD6EE;
}
</style>